/**
 * 抬杠 
 */

/***
 * 1. 每帧都要更新；
 * 2. 缓存5帧
 */
import * as THREE from 'three'

import { disposeO3D } from '../js/threejsHelper';
/**
 * 显示隐藏标识；
 */

let show_channel = true
/**
 * 模型缓存5帧之后，清除
 */
let model_clear_flag = 5;
/**
 * 存放模型的map
 */
let model_map = new Map()

let model_group = null;

/**
 * 
 */
export const load_fused_track_movable_gate = (vehicleData, scene) => {
    try {
        if (!vehicleData) {
            return;
        }
        if (vehicleData.trackList?.movableGateList?.length > 0) {
            clearGroupMap(model_map);
            model_clear_flag = 5;//有新数据时，更新要缓存标记
            let origin = vehicleData.origin;
            vehicleData.trackList?.movableGateList?.forEach(item => {
                if (show_channel) {
                    rander_item(item, scene, origin)
                }
            })
        } else {
            model_clear_flag--
            if (model_clear_flag < 0) {
                clearGroupMap(model_map);
            }
        }
    } catch (error) {
        console.log(error);
    }
}

export const clear_model_handler = () => {
    clearGroupMap(model_map);
}

/**
 * 渲染单个movable gate
 * @param {*} movableGateInfo 
 */
function rander_item(movableGateInfo, scene, origin) {
    //
    if (model_map.has(movableGateInfo.id)) {
        //当已经渲染了该模型时；不再重复渲染
        changeBoxColor(model_map.get(movableGateInfo.id), movableGateInfo);
        return
    } else {
        let { startPosition, endPosition } = movableGateInfo
        let vector_start = new THREE.Vector2(startPosition.x, startPosition.y);
        let vector_end = new THREE.Vector2(endPosition.x, endPosition.y);

        let length = vector_start.distanceTo(vector_end);
        let width = 0.2;
        let height = startPosition.z - origin.z;
        let material_mesh = getMaterial(movableGateInfo.movingStatus)
        let box = createBox(length, height, width, material_mesh);
        if (!model_group) {
            model_group = new THREE.Group();
            scene.add(model_group)
        }
        let center_x = (vector_end.x + vector_start.x) / 2;
        let center_y = (vector_end.y + vector_start.y) / 2;
        let heading = Math.atan2(vector_end.y - vector_start.y, vector_end.x - vector_start.x);
        box.position.set(center_x, center_y, 0.001 + height / 2)
        box.rotation.set(0, 0, heading)
        box.movingStatus = movableGateInfo.movingStatus;
        box.gateType = movableGateInfo.gateType;
        model_group.add(box)
        model_map.set(movableGateInfo.id, box)
    }
}


/**
 * 清理模型
 * @param {*} map 
 */
const clearGroupMap = (map) => {
    for (let [key, model] of map) {
        model.visible = false;
        disposeO3D(model)
    }
    map.clear();
}

function createBox(length = 0, height = 0, width = 0, material) {
    const geometry = new THREE.BoxGeometry(length, width, height)
    const box = new THREE.Mesh(geometry, material);
    return box;
}

let material_map = new Map();
function getMaterial(type) {
    if (material_map.has(type)) {
        return material_map.get(type);
    }
    let color = getColor(type);
    let material_mesh = new THREE.MeshBasicMaterial({
        color: color,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.5
    })
    material_map.set(type, material_mesh)
    return material_mesh
}

function getColor(GateMovingStatus) {
    let color = 0x009ad6
    switch (GateMovingStatus) {
        case 0:
            color = 0x102b6a;//青蓝 GATE_MOVING_UNKNOWN
            break;
        case 1:
            color = 0xfedcbd;//藤紫  GATE_OPENING
            break;
        case 2:
            color = 0xe0861a;//黄色 GATE_CLOSING 
            break;
        case 3:
            color = 0x006c54; //绿色 GATE_OPENED
            break;
        case 4:
            color = 0xd71345;//红色 GATE_CLOSED
            break;
    }
    return color;
}

function changeBoxColor(box, movableGateInfo) {
    if (movableGateInfo.movingStatus != box.movingStatus) {
        if (box && box.material) {
            let material = getMaterial(movableGateInfo.movingStatus)
            box.material = material
            box.movingStatus = movableGateInfo.movingStatus
            box.gateType = movableGateInfo.gateType
        }
    }
}